import { createSlice } from '@reduxjs/toolkit';

const ordersSlice = createSlice({
    name: 'orders',
    initialState: {
        orders: [],
        limitOrders: [],
        allMarketData: [],
        previousAllMarketData: [],
        loading: true,
        error: null,
    },
    reducers: {
        fetchOrdersRequest: (state) => {
            state.loading = true;
        },
        fetchOrdersSuccess: (state, action) => {
            state.loading = false;
            state.orders = action.payload;
        },

        fetchOrdersFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },

        fetchLimitOrdersRequest: (state) => {
            state.loading = true;
        },

        deleteLimitOrderRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        deleteLimitOrderSuccess: (state, action) => {
            state.loading = false;
            state.orders = action.payload;
        },

        deleteLimitOrderFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },

        fetchLimitOrdersSuccess: (state, action) => {
            state.loading = false;
            state.limitOrders = action.payload;
        },
        fetchLimitOrdersFailure: (state, action) => {
            state.error = action.payload;
        },
        fetchMarketDataRequest: (state) => { },

        fetchMarketDataSuccess: (state, action) => {
            state.previousAllMarketData = state.allMarketData;
            state.allMarketData = action.payload;
        },
        fetchMarketDataFailure: (state, action) => {
            state.allMarketData = state.previousAllMarketData;
            state.error = action.payload;
        },
    },
});

export const {
    fetchOrdersRequest,
    fetchOrdersSuccess,
    fetchOrdersFailure,
    deleteLimitOrderRequest,
    deleteLimitOrderSuccess,
    deleteLimitOrderFailure,
    fetchLimitOrdersRequest,
    fetchLimitOrdersSuccess,
    fetchLimitOrdersFailure,
    fetchMarketDataRequest,
    fetchMarketDataSuccess,
    fetchMarketDataFailure,
} = ordersSlice.actions;

export default ordersSlice.reducer;